import request from '../utils/request'
import { CREATE_USER, USERNAME_NOT_EXISTS_USER, RETRIEVE_USER_FROM_TOKEN, LOGIN_USER, GENERATE_TOKEN_PASSWORD,
 VERIF_TOKEN_PASSWORD, CHANGE_PASSWORD } from './UserConstants'
import { browserHistory } from 'react-router';
import { addNotifSuccess, addNotifError } from '../notification/NotificationActions'


export const createUser = (values) => {
    return {
        type: CREATE_USER,
        payload: request.post('provider/new/', values)
    }
};

export const usernameNotExistsUser = (values) => {
    return {
        type: USERNAME_NOT_EXISTS_USER,
        payload: request.post('/auth/check/', values)
    }
};

export const retrieveUserFromToken = () => {
    return {
        type: RETRIEVE_USER_FROM_TOKEN,
        payload: request.get('/auth/me/')
    }
};

export function loginUser(values){
  return {
        type: LOGIN_USER,
        payload: request.post('auth/login/', values)
    }
}

export function generateTokenPassword(values){
  return {
        type: GENERATE_TOKEN_PASSWORD,
        payload: request.post('auth/generate-token-password/', values)
    }
}

export const verifTokenChangePassword = (token) => {
    return {
        type: VERIF_TOKEN_PASSWORD,
        payload: request.get('/auth/change-password/'+token+'/')
    }
};


export const changePassword = (token, password) => {
    return {
        type: CHANGE_PASSWORD,
        payload: request.post('/auth/change-password/'+token+'/', {password})
    }
};

export function logoutUser(){
  return function(dispatch){
      dispatch({type:'LOGOUT_USER'});
      request.defaults.headers.common['Authorization'] = "";
      localStorage.removeItem('token');
      localStorage.clear();
      browserHistory.push('/');
      window.location.reload()
  }
}


export function login(values){
  return function(dispatch){
    return dispatch(loginUser(values))
        .then((response) => {
            localStorage.setItem('token', response.action.payload.data.token);
            request.defaults.headers.common['Authorization'] = 'Token ' + response.action.payload.data.token
            
            if(response.action.payload.data.role === "provider")
               browserHistory.push('/prestataire/fiche')
             else
               browserHistory.push('/manager/dashboard')

        }).catch((error) => {
            
            dispatch(addNotifError("L'email et le mot de passe ne correspondent pas", "Erreur"))

        })
  }
}

export function registerFormLead(values){
   return function(dispatch){
        dispatch(createUser(values))
        .then((response) => {
              console.log(response.action.payload.data)
          }).catch((error) => {
              dispatch(addNotifError("Veuillez recommander", "Erreur"))
          })
    }
}



export function registerForm(values) {
    //Force one region not clean but no more time
    values.region = 1;
    return function(dispatch){
        dispatch(createUser(values))
        .then((response) => {

              localStorage.setItem('token', response.action.payload.data.token);
              request.defaults.headers.common['Authorization'] = 'Token ' + response.action.payload.data.token;
              browserHistory.push('/confirmation')
      
          }).catch((error) => {
              
              dispatch(addNotifError("Veuillez recommander", "Erreur"))

          })
    }
}









// WEBPACK FOOTER //
// ./src/user/UserActions.js